import { Outlet } from "@tanstack/react-router";

import { ReportBuilderEditorProvider } from "@pages/ReportStudio/ReportBuilder/editor/context";

import { AppRecordingDock } from "./RecordingDock/AppRecordingDock";
import { RecordingHost } from "./RecordingDock/RecordingHost";
import { SideNavigation } from "./SideNavigation";

const Layout = () => {
  return (
    <ReportBuilderEditorProvider>
      <div className="grid h-dvh w-screen grid-cols-[auto_1fr] bg-background transition-all duration-300">
        <SideNavigation />

        <main className="overflow-x-hidden bg-background">
          <Outlet />
        </main>

        {/* Assessment Scribe - persistent recording dock */}
        <RecordingHost />
        <AppRecordingDock />
      </div>
    </ReportBuilderEditorProvider>
  );
};

export default Layout;
